import React from "react";
import affiliation from "../../../images/homeimage/affiliation.jpeg"
const AffiliationSection5 = () => {
  return (
   
    <div id="history">
    <div className="parallax h-96  bg-fixed bg-top bg-no-repeat md:h-80 lg:mt-10"  style={{backgroundImage:`url('${affiliation}')`}}>
      <div className="absolute flex h-96 w-full flex-col items-center justify-around bg-[#002147;] opacity-70 md:h-80 md:flex-row md:px-32">
        <div className="w-11/12 md:w-1/2">
          <div className="my-3 text-4xl font-bold text-white">Affiliation</div>
          {/* <div className="my-2 text-xl font-medium text-white">
            Fall 2019 applications BLOG open
          </div> */}
          <div className="text-lg text-white ">
            S. S. Public School is a co-educational{" "}
            <a className="text-yellow-400">English Medium School </a>
            affiliated to State Board{" "}
            <a className="text-yellow-400"> Affiliation Number 13497503</a>. The
            school aims at imparting quality education with its goals set on all
            round personality development of its students. The school has been
            setting records by giving 100% result in Examinations.
          </div>
        </div>
        <div>
          {/* <button className="mt-4 w-fit rounded-lg bg-yellow-400 p-1 px-8 py-3 text-base font-bold text-[#002147;]">
            Read More
          </button> */}
        </div>
      </div>
    </div>
    </div>
  );
};

export default AffiliationSection5;
